import React from 'react';

import { ContentCopyOutlined, InventoryOutlined } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';

type TextFieldProps = Parameters<typeof TextField>[0];
type Props = {
  label?: TextFieldProps['label'];
  value: string;
  size?: TextFieldProps['size'];
  helperText?: TextFieldProps['helperText'];
  margin?: TextFieldProps['margin'];
};
export default function CopyTextInput({ size = 'small', ...props }: Props) {
  const [isCopied, setIsCopied] = React.useState(false);

  async function copyToClipboard() {
    await navigator.clipboard.writeText(props.value);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  }

  return (
    <TextField
      size={size}
      {...props}
      fullWidth
      onFocus={(event) => {
        event.target.select();
      }}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={isCopied ? 'Copied!' : 'Copy to clipboard'}>
              <IconButton type="button" onClick={copyToClipboard} aria-label="Copy URL" edge="end">
                {isCopied ? <InventoryOutlined sx={{ fontSize: 16 }} /> : <ContentCopyOutlined sx={{ fontSize: 16 }} />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  );
}
